/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/System/Broadcasting/Enums/ReleaseEvent.php */
export const releaseEvent = {
	Announced: 'announced',
} as const

/** @see backend/nexus/modules/System/Broadcasting/Enums/ReleaseEvent.php */
export type ReleaseEvent = (typeof releaseEvent)[keyof typeof releaseEvent]
